import { useLayer } from '@coursera-web/statsig';

export const MERCH_PILLS_LAYER = 'merch-pills-card-and-xdp';

/**
 * Gates the new merchandising pills (Recently updated, Bestseller, Hot new release) on the product card and
 * XDP hero behind the `merch-pills-card-and-xdp` statsig layer (CVR-2724, CVR-2736, CVR-2737).
 * The layer param is only read when the card qualifies for a pill, so only learners who could
 * actually see it are exposed to the experiment.
 */
export const useShouldShowNewMerchPills = (isQualifyingCard: boolean) => {
  const layer = useLayer(MERCH_PILLS_LAYER);

  if (!isQualifyingCard) {
    return false;
  }

  return layer.get('show-new-merch-pills', false);
};
